import { FormDetails } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockFormDetails: FormDetails = {
  id: 'form_123',
  internalName: 'Test Form Internal',
  title: 'Test Form',
  description: 'This is a test form description',
  logo: 'https://example.com/logo.png',
  primaryColor: '#FF0000',
  secondaryColor: '#0000FF',
  partner: { id: 'partner-123', name: 'Test Partner' },
  pages: [
    {
      id: 'page_1',
      title: 'General Information',
      description: 'Please provide the following information',
      order: 1,
      questions: [
        {
          id: 'q_text',
          type: 'text',
          label: 'Project Name',
          description: 'Enter the name of your project',
          placeholder: 'Enter project name',
          required: true,
          order: 1
        },
        {
          id: 'q_textarea',
          type: 'textarea',
          label: 'Project Description',
          description: 'Provide a detailed description',
          placeholder: 'Enter description',
          required: true,
          order: 2
        },
        {
          id: 'q_score',
          type: 'score',
          label: 'Impact Score',
          description: 'Rate the expected impact',
          required: false,
          maxScore: 5,
          order: 3
        },
        {
          id: 'q_award_amount',
          type: 'award_amount',
          label: 'Requested Amount',
          description: 'Enter the amount you are requesting',
          placeholder: 'Enter amount',
          required: true,
          order: 4
        }
      ]
    },
    {
      id: 'page_2',
      title: 'Additional Details',
      description: 'Please answer the following questions',
      order: 2,
      questions: [
        {
          id: 'q_select',
          type: 'select',
          label: 'Organization Type',
          description: 'Select your organization type',
          placeholder: 'Select an option',
          required: true,
          order: 1,
          options: [
            { label: 'Nonprofit', value: 'nonprofit', conditionalQuestionIds: ['q_radio'] },
            { label: 'Education', value: 'education' },
            { label: 'Social Impact', value: 'social_impact' }
          ]
        },
        {
          id: 'q_award_recommendation',
          type: 'award_recommendation',
          label: 'Award Recommendation',
          description: 'Select your recommendation',
          placeholder: 'Select recommendation',
          required: false,
          order: 2,
          options: [
            { label: 'Approve', value: 'approve' },
            { label: 'Reject', value: 'reject' }
          ]
        },
        {
          id: 'q_radio',
          type: 'radio',
          label: 'First Time Applicant',
          description: 'Is this your first time applying?',
          required: true,
          hidden: true,
          order: 3,
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ]
        },
        {
          id: 'q_checkbox',
          type: 'checkbox',
          label: 'Areas of Interest',
          description: 'Select all that apply',
          required: false,
          order: 4,
          options: [
            { label: 'Education', value: 'education' },
            { label: 'Healthcare', value: 'healthcare' },
            { label: 'Environment', value: 'environment' }
          ]
        },
        {
          id: 'q_documents',
          type: 'documents',
          label: 'Supporting Documents',
          description: 'Upload any supporting documents',
          required: false,
          order: 5
        },
        {
          id: 'q_decision',
          type: 'decision',
          label: 'Final Decision',
          description: 'Make your decision',
          required: true,
          order: 6,
          options: [
            { label: 'Yes', value: 'decision_yes', key: 'pass' },
            { label: 'No', value: 'decision_no', key: 'fail' }
          ]
        },
        {
          id: 'q_nominator_group',
          key: 'nomination.nominator.group',
          type: 'select',
          label: 'Nominator Group',
          description: 'Select your nominator group',
          required: false,
          order: 7,
          options: [
            { label: 'Group A', value: 'group_a' },
            { label: 'Group B', value: 'group_b' }
          ]
        },
        {
          id: 'q_multi_select',
          type: 'select',
          label: 'Focus Areas',
          description: 'Select all that apply',
          placeholder: 'Pick multiple',
          required: true,
          multiple: true,
          order: 8,
          options: [
            { label: 'Education', value: 'education' },
            { label: 'Healthcare', value: 'healthcare' },
            { label: 'Environment', value: 'environment' }
          ]
        }
      ]
    }
  ]
}
